// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"146":"6e439772","154":"7f1c27b2","230":"5bd46cba","644":"f0d246b2","955":"c54d67ef","996":"72089d7b"}[chunkId] + ".chunk.js";
};